type PriceKey = 'initPrice' | 'trafficPrice' | 'hourPerPrice' | 'callPerPrice';
type Language = 'ko' | 'en';

type PriceLabels = Record<PriceKey, Record<Language, string>>;

const PRICE_LABELS: PriceLabels = {
    initPrice: {
        ko: '초기 설치비용',
        en: 'Initial Setup Fee',
    },
    trafficPrice: {
        ko: '트래픽 비용',
        en: 'Traffic Cost',
    },
    hourPerPrice: {
        ko: '1시간당 비용',
        en: 'Cost per Hour',
    },
    callPerPrice: {
        ko: '호출 건당',
        en: 'Cost per Call',
    },
} as const;

export const getPriceLabel = (key: string, language: string): string => {
    const priceKey = key as PriceKey;
    const lang = (language === 'en' ? 'en' : 'ko') as Language;

    return PRICE_LABELS[priceKey]?.[lang] || PRICE_LABELS[priceKey]?.ko || '';
};
